import { render, staticRenderFns } from "./DefaultList.vue?vue&type=template&id=9ea4fa6a&scoped=true"
import script from "./DefaultList.vue?vue&type=script&lang=js"
export * from "./DefaultList.vue?vue&type=script&lang=js"
import style0 from "./DefaultList.vue?vue&type=style&index=0&id=9ea4fa6a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea4fa6a",
  null
  
)

export default component.exports